export type ApiInitAiLabResponse = {
    total_times: number;
    used_times: number;
    permissions: { [key:string]: boolean };
};

export const InitAiLab = Symbol('InitAiLab');

export interface InitAiLab {
    initAiLab(): Promise<ApiInitAiLabResponse>;
}